import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { collection, getDocs, orderBy, query } from 'firebase/firestore'
import { db } from '@/config/firebase'
import { TransporterDriverUserRequest } from '@otw/models/transporter'

const REQUESTS_COLLECTION = 'transporter_driver_user_requests'

export const useTransporterDriverRequests = () => {
  const { data: requests = [], isLoading, refetch, error } = useQuery({
    queryKey: ['transporter_driver_user_requests'],
    queryFn: async () => {
      const requestsCollection = collection(db, REQUESTS_COLLECTION)
      const requestsQuery = query(requestsCollection, orderBy('created_at', 'desc'))
      const snapshot = await getDocs(requestsQuery)
      return snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...(docSnap.data() as Omit<TransporterDriverUserRequest, 'id'>),
      }))
    },
  })

  const pendingRequests = useMemo(
    () => requests.filter((request) => request.status === 'pending'),
    [requests]
  )

  return {
    requests,
    pendingRequests,
    isLoading,
    refetch,
    error: error instanceof Error ? error.message : null,
  }
}
